import { AmsListItemBase } from "./AmsListItemBase";
import * as XCol from '../../framework.core/XExportColumn';

export class AciManifestListItem extends AmsListItemBase  {
    id: string = '';
    userId: string = '';
    transMode: string = '';
    blocked: boolean|null = null;
    aciStatus: string = '';
    matchStatus: string = '';
    dpStatus: string = '';
    actionDate: string | null = null;
    fromActionDate: string | null = null;
    toActionDate: string | null = null;
    responseAt: string | null = null;
    fromResponseAt: string | null = null;
    toResponseAt: string | null = null;
    manifestSeq: string = '';
    primaryBill: string = '';
    primarySCAC: string = '';
    primaryCCN: string = '';
    houseBill: string = '';
    houseSCAC: string = '';
    houseCCN: string = '';
    etd: string | null = null;
    fromETD: string | null = null;
    toETD: string | null = null;
    eta: string | null = null;
    fromETA: string | null = null;
    toETA: string | null = null;
    discPortDesc: string = '';
    dischargePort: string = '';
    portName: string = '';
    shipper: string = '';
    consignee: string = '';
    cntrNo: string = '';
    createdBy: string = '';
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Id', width: 40, dataIndex: 'id', hiddenInColumnSetup: true, align: XCol.XAlignType.Right }),
        XCol.Create({ col: 1, text: 'User', width: 90, dataIndex: 'userId', align: XCol.XAlignType.Right, hiddenInColumnSetup: true}),
        XCol.Create({ col: 2, text: 'T.Mode', width: 50, dataIndex: 'transMode'}),
        XCol.Create({ col: 3, text: 'Block', width: 40, dataIndex: 'blocked', type: XCol.XCellType.Bool, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'ST', width: 50, dataIndex: 'aciStatus', align: XCol.XAlignType.Center }),
        XCol.Create({ col: 5, text: 'MT', width: 50, dataIndex: 'matchStatus'}),
        XCol.Create({ col: 6, text: 'DP', width: 50, dataIndex: 'dpStatus'}),
        XCol.Create({ col: 7, text: 'Send Date', width: 80, dataIndex: 'actionDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 8, text: 'Response Date', width: 90, dataIndex: 'responseAt', type: XCol.XCellType.Date}),
        XCol.Create({ col: 9, text: 'Manifest #', width: 140, dataIndex: 'manifestSeq'}),
        XCol.Create({ col: 10, text: 'Primary CCN', width: 130, dataIndex: 'primaryBill'}),
        XCol.Create({ col: 11, text: 'House CCN', width: 130, dataIndex: 'houseBill',  defaultColumnFocus : true}),
        XCol.Create({ col: 12, text: 'ETD', width: 90, dataIndex: 'etd', type: XCol.XCellType.Date}),
        XCol.Create({ col: 13, text: 'ETA', width: 90, dataIndex: 'eta', type: XCol.XCellType.Date}),
        XCol.Create({ col: 14, text: 'Discharge Port', width: 180, dataIndex: 'discPortDesc'}),
        XCol.Create({ col: 15, text: 'Shipper', width: 190, dataIndex: 'shipper'}),
        XCol.Create({ col: 16, text: 'Consignee', width: 140, dataIndex: 'consignee'}),
        XCol.Create({ col: 17, text: 'Container #', width: 110, dataIndex: 'cntrNo'}),
        XCol.Create({ col: 18, text: 'Create By', width: 90, dataIndex: 'createdBy'}),
        XCol.Create({ col: 19, text: 'Create At', width: 120, dataIndex: 'createdAt',  type: XCol.XCellType.DateTime})

    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static formatData(data: AciManifestListItem[]) {
        return data.map((d: AciManifestListItem) => ({
          ...d,
        }));
    }



    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        actionDate: {from: 'fromActionDate', to: 'ToActionDate' },
        responseAt: {from: 'fromResponseAt', to: 'toResponseAt' },
        etd: {from: 'fromETD', to: 'toETD'},
        eta: {from: 'fromETA', to: 'toETA'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
    }


}
